// PARAMETERS
export const ParameterFields = [
  { title: "LVOT", range: "24-26 mm" },
  { title: "RVOT", range: "35 mm" },
  { title: "MPA", range: "25-35 mm" },
  { title: "TVA", range: "" },
  { title: "MVA", range: "(mm)" },
  { title: "RV", range: "33 mm" },
  { title: "RA", range: "30-45 mm" },
];
export default ParameterFields;
